// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { ShopifyProvider } from "./context/StoreContext";
import Promociones from "./pages/Promociones";
import "./App.css";

import NavBar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Catalogo from "./pages/Catalogo";
import Carrito from "./pages/Carrito";
import ProductDetail from "./pages/ProductDetail";
import Contacto from "./pages/Contacto";
import PoliticasPrivacidad from "./pages/PoliticasPrivacidad";
import PoliticasReembolso from "./pages/PoliticasReembolso";
import TerminosServicio from "./pages/TerminosServicio";
import Admin from "./pages/Admin";
import Premios from "./pages/Premios";
import OfertasVirales from "./pages/OfertasVirales";
import CampaignLanding from "./pages/CampaignLanding";
import DigitalCampaignLanding from "./pages/DigitalCampaignLanding";

const MainLayout = () => (
  <>
    <NavBar />
    <Outlet />
    <Footer />
  </>
);

function App() {
  return (
    <ShopifyProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Panel admin — sin navbar/footer */}
          <Route path="/admin" element={<Admin />} />
          <Route path="/premios" element={<Premios />} />
          <Route path="/l/:slug" element={<CampaignLanding />} />
          <Route path="/d/:slug" element={<DigitalCampaignLanding />} />

          {/* Rutas principales */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/catalogo" element={<Catalogo />} />
            <Route path="/catalogo/:categoria" element={<Catalogo />} />
            <Route path="/carrito" element={<Carrito />} />
            <Route path="/checkout" element={<Navigate to="/carrito" replace />} />
            <Route path="/producto/:id" element={<ProductDetail />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route
              path="/politicas-privacidad"
              element={<PoliticasPrivacidad />}
            />
            <Route
              path="/politicas-reembolso"
              element={<PoliticasReembolso />}
            />
            <Route path="/terminos-servicio" element={<TerminosServicio />} />
            <Route path="/promociones" element={<Promociones />} />
            <Route path="/ofertas-virales" element={<OfertasVirales />} />
          </Route>
        </Routes>
      </Router>
    </ShopifyProvider>
  );
}

export default App;
